export type ProblemEntry = {
  kind: 'problem'
  id: number
  label: string
  diagnosis: string
}

export type ProcedureEntry = {
  kind: 'procedure'
  id: number
  label: string
  code: string
}

// What is on the visit: the patient's own problems and the practice's procedures.
export type PickerEntry = ProblemEntry | ProcedureEntry

export type PickerKey = `${PickerEntry['kind']}:${number}`

// Read by the save flow; dirty means the operator changed the set since it was seeded.
export type AppointmentIssuesSelection = {
  issueIds: number[]
  procedureCodeIds: number[]
  dirty: boolean
}

export const EMPTY_ISSUES_SELECTION: AppointmentIssuesSelection = {
  issueIds: [],
  procedureCodeIds: [],
  dirty: false,
}
